/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trash_TitleInputs */

const en_trash_title = /** @type {(inputs: Trash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trash`)
};

const de_trash_title = /** @type {(inputs: Trash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papierkorb`)
};

/**
* | output |
* | --- |
* | "Trash" |
*
* @param {Trash_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const trash_title = /** @type {((inputs?: Trash_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trash_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_trash_title(inputs)
	return en_trash_title(inputs)
});